import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { CreditCard, Building } from "lucide-react";

interface PaymentTypeSelectProps {
  value: "credit" | "bank";
  onValueChange: (value: "credit" | "bank") => void;
}

export const PaymentTypeSelect = ({ value, onValueChange }: PaymentTypeSelectProps) => {
  return (
    <div className="space-y-2">
      <label className="text-lg font-medium">Payment Method</label>
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger className="w-full border border-[#E5DEFF] focus:ring-[#9b87f5] h-14">
          <SelectValue placeholder="Select payment method" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="credit">
            <div className="flex items-center">
              <CreditCard className="w-4 h-4 mr-2 text-[#9b87f5]" />
              Credit Card
            </div>
          </SelectItem>
          <SelectItem value="bank">
            <div className="flex items-center">
              <Building className="w-4 h-4 mr-2 text-[#9b87f5]" />
              Bank Account
            </div>
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};